export default __webpack_public_path__ + "static/media/ui_icon_pencil.f45495ab.svg";